"use client";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center space-y-4">
        <h2 className="font-pressStart2P text-sm text-red-400">something went wrong</h2>
        <button
          onClick={reset}
          className="font-pressStart2P text-xs text-white/60 hover:text-white transition-colors"
        >
          try again
        </button>
      </div>
    </div>
  );
}
